import { Box } from '@mui/material';
import { FormFieldsData, ModalForm } from 'framework/form';
import { SideDrawer } from 'framework/ui/mui-builder';
import InterruptionCreateFields from './InterruptionCreateFields';
import InterruptionDrawerSubmitButton from '../InterruptionDrawerSubmitButton';
import { getInterruptionCreateValidationSchema } from '../validation';
import useCreateCallbackInterruptionSubmit from './useCreateCallbackInterruptionSubmit';
import { InterruptionCreateFormValues } from '../../types';

type CallbackInterruptionDrawerProps = {
  isOpen: boolean;
  onClose: () => void;
};

const DRAWER_CONTENT_SX = {
  width: '100%',
  minHeight: 0,
} as const;

const FORM_MESSAGE_CONTEXT = 'callbackInterruptionDrawer';

const CallbackInterruptionDrawer = ({ isOpen, onClose }: CallbackInterruptionDrawerProps) => {
  const { createCallbackInterruption } = useCreateCallbackInterruptionSubmit();

  const submit = async (values: FormFieldsData<InterruptionCreateFormValues>) => {
    await createCallbackInterruption(values);
    onClose();
  };

  return (
    <SideDrawer
      title="Request callback now"
      isOpen={isOpen}
      onClose={onClose}
      width={600}
      content={
        <Box sx={DRAWER_CONTENT_SX}>
          {isOpen ? (
            <ModalForm
              closeModal={onClose}
              modalOpen={isOpen}
              isCloseAfterSubmit={false}
              isHideDefaultButtons
              getValidationSchemaFunc={getInterruptionCreateValidationSchema}
              submitFormFunc={submit}
              messageContext={FORM_MESSAGE_CONTEXT}
            >
              <InterruptionCreateFields />
              <InterruptionDrawerSubmitButton />
            </ModalForm>
          ) : null}
        </Box>
      }
    />
  );
};

export default CallbackInterruptionDrawer;
